import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { DocumentModel } from '../models/document.model';
import { AutosaveModel } from '../models/autosave.model';

@Injectable()
export class AutosaveService {
  constructor(private api: ApiService) {}

  create(document: DocumentModel, txTextSessionID: string, autosaveSessionId: string): Observable<any> {
    let base64: string = '';
    if (txTextSessionID == null || txTextSessionID === '') {
      // pdf
      base64 = document.document ?? '';
    }
    return this.api.post(
      'autosave/checkpoint',
      {
        dcmID: document.dcmID,
        filename: document.filename,
        casID: document.casID,
        txTextSessionId: txTextSessionID,
        autosaveSessionId: autosaveSessionId,
        PraSysId: document.praSysId,
        document: base64,
      },
      {
        showToast: false,
      }
    );
  }

  getByStaffId(staffId: string): Observable<Array<AutosaveModel>> {
    return this.api.post(
      'autosave/getbystaffid',
      { staffId: staffId },
      {
        showToast: false,
      }
    );
  }

  getByCasId(casId: string): Observable<Array<AutosaveModel>> {
    return this.api.post(
      'autosave/getbycasid',
      { casID: casId },
      {
        showToast: false,
      }
    );
  }

  getBySessionId(sessionId: string, txTextSessionID: string, isPdf: boolean = false): Observable<DocumentModel> {
    return this.api.post(
      'autosave/GetBySessionId',
      { AutosaveSessionId: sessionId, txTextSessionId: txTextSessionID, isPdf: isPdf },
      {
        showToast: false,
      }
    );
  }

  delete(sessionId: string): Observable<any> {
    return this.api.post(
      'autosave/delete',
      { AutosaveSessionId: sessionId },
      {
        showToast: false,
      }
    );
  }

  deleteBeacon() {
    this.api.sendBeacon('autosave/deletebeacon', {});
  }

  updateBeforeUnloadBeacon() {
    this.api.sendBeacon('autosave/updatebeforeunloadbeacon', {});
  }

  forceAutosaveBeacon(document: DocumentModel, txTextSessionID: string, autosaveSessionId: string) {
    let base64: string = '';
    if (txTextSessionID == null || txTextSessionID === '') {
      base64 = document.document ?? '';
    }
    return this.api.sendBeacon(
      'autosave/checkpoint',
      {
        dcmID: document.dcmID,
        filename: document.filename,
        casID: document.casID,
        txTextSessionId: txTextSessionID,
        autosaveSessionId: autosaveSessionId,
        PraSysId: document.praSysId,
        document: base64,
        isBeforeUnloadSave: true,
      }
    );
  }
}
